import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import { Avatar, CardHeader, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TagsKanbanContainer } from "../TagsKanbanContainer";

const useStyles = makeStyles(theme => ({
	headerText: {
		fontWeight: 600,
		fontSize: "1rem",
		color: theme.palette.text.primary,
	},
	subheaderText: {
		fontSize: "0.8rem",
		color: theme.palette.text.secondary,
	},
	avatar: {
		width: 44,
		height: 44,
		border: `2px solid ${theme.palette.divider}`,
	}
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const classes = useStyles();
	const [amount, setAmount] = useState("");

	const renderCardReader = () => {
		return (
			<CardHeader
				onClick={onClick}
				style={{ cursor: "pointer", padding: "0 8px" }}
				titleTypographyProps={{ noWrap: true, className: classes.headerText }}
				subheaderTypographyProps={{ noWrap: true, className: classes.subheaderText }}
				avatar={<Avatar src={contact?.urlPicture} alt="contact_image" className={classes.avatar} />}
				title={`${contact?.name || '(sem contato)'} #${ticket.id}`}
				subheader={
					ticket.user &&
					`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
				}
			/>
		);
	}

	const handleChange = (event) => {
		const value = event.target.value;

		setAmount(value);
	}


	return (
		<React.Fragment>
			<Grid container alignItems="center" spacing={10}>
				{/* Conteúdo do contato à esquerda */}
				<Grid item xs={6}>
					{renderCardReader()}
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default TicketInfo;
